<template>
    <p
        v-if="status == 'ready'"
        class="font--14 lh--18 p-32 text-dark mb-0 bg-light overflow-y-auto"
        style="white-space: pre-line"
    >
        {{ text }}
    </p>

    <div
        v-else-if="status == 'error'"
        class="p-32 text-center text-white"
    >
        <p>{{ errorMessage }}</p>
        ¯\_(ツ)_/¯
    </div>

    <spinner-block v-else />
</template>

<script>
import SpinnerBlock from "~/components/elements/SpinnerBlock"
import AjaxCtx from "~/lib/AjaxCtx"
import { notify } from "~/lib/bugsnag"

export default {
    props: {
        url: {
            type: String,
            required: true,
        },

        withoutCredentials: {
            type: Boolean,
            default: false,
        },
    },

    emits: ["accessed"],

    data() {
        return {
            text: "",
            status: "loading", // loading | error | ready
            errorMessage: "",
        }
    },

    async created() {
        const ctx = new AjaxCtx("", {
            credentials: this.withoutCredentials ? "omit" : "include",
            headers: this.$http.defaults.headers,
        })

        try {
            this.text = await ctx.fetch(this.url).then(res => res.text())
            this.status = "ready"
            this.$emit("accessed")
        } catch (e) {
            notify(e)
            this.status = "error"
            this.errorMessage = e.message
        }
    },

    components: {
        SpinnerBlock,
    },
}
</script>
